export default __webpack_public_path__ + "static/media/economics-card.edf71f1d.webp";